module.exports = __webpack_public_path__ + "img/dy_hx.2b0c5e4a.png";